export enum ContactType {
  Phone = 'phone',
  Landline = 'landline',
  Email = 'email',
  Website = 'website',
  Ticket = 'ticket',
  Name = 'name',
  TicketPrintInfo = 'ticket-print-info',
}
